import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles((theme) => ({
	paper: {
		width: "100%"
	},
	adminChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100]),
		height: theme.spacing(3)
	},
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[700]
	}
}))

export default useStyles
